const API = {
  version: '/', // 版本
  user: '/user', // 当前登录用户
  locations: '/coupons/locations', // 更新当前登录用户的坐标
  wxtoken: '/wx/token', // 获取微信 js sdk 签名
  groupons: '/groupons', // 获取拼团活动
  orders: '/groupons/orders', // 买家订单列表
  affiorders: '/groupons/affi/orders', // 卖家订单列表
  affigroupons: '/groupons/affi', // 卖家拼团列表
  scan: '/groupons/affi/scan' // 商家扫码验券
}

export default {
  install (Vue, name = '$api') {
    Object.defineProperty(Vue.prototype, name, { value: API })
  }
}
